module.exports = __webpack_public_path__ + "assets/img/bg_分中心.ffdcecf2.png";